import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;
let connecting: Promise<Socket> | null = null;

export async function getAuthedSocket(
  getAccessTokenSilently: () => Promise<string>,
): Promise<Socket> {
  if (socket) return socket;
  if (connecting) return connecting;

  connecting = (async () => {
    const token = await getAccessTokenSilently();

    const s = io("/", {
      auth: { token: `Bearer ${token}` },
      withCredentials: true,
      // path: "/socket.io", // set if you customized it server-side
      transports: ["websocket"], // optional, if you want to skip polling
    });

    await new Promise<void>((resolve, reject) => {
      const onConnect = () => {
        s.off("error", onError);
        resolve();
      };
      const onError = (err: Error) => {
        s.off("connect", onConnect);
        reject(err);
      };
      s.once("connect", onConnect);
      s.once("error", onError);
    });

    socket = s;
    connecting = null;

    return s;
  })();

  return connecting;
}

export function resetAuthedSocket() {
  socket?.disconnect();
  socket?.removeAllListeners();

  socket = null;
  connecting = null;
}
